// extracted by mini-css-extract-plugin
module.exports = {"root":"NoAvailability_root__1hZ1C","title":"NoAvailability_title__1tLLT","icon":"NoAvailability_icon__32JwF"};